module.exports = __webpack_public_path__ + "img/49_3.da018808.png";